const SHOW_WELCOME_POPUP_KEY = 'showWelcomePopup';

export const getShowWelcomePopupFromStorage = (): boolean => {
    try {
        const value = sessionStorage.getItem(SHOW_WELCOME_POPUP_KEY);
        if (value === null) {
            return false;
        }
        return JSON.parse(value);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Failed to parse showWelcomePopup from sessionStorage:', error);
        return false;
    }
};

export const storeShowWelcomePopupInStorage = (value: boolean): void => {
    try {
        sessionStorage.setItem(SHOW_WELCOME_POPUP_KEY, JSON.stringify(value));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to set showWelcomePopup in sessionStorage:', error);
    }
};
